/**
 * 选择账号类型
 */
import { Modal } from "antd";
import styles from "./index.module.scss";
import { useTranslation } from "next-i18next";
import Image from "next/image";
import { version, Url, cdnHost } from "@/utils";
import { clickEvent, track } from "@/sdk/sensors";

interface SelectAccountProps {
  open?: boolean;
  cancel: Function;
}
const SelectAccount = (props: SelectAccountProps): JSX.Element => {
  const { t } = useTranslation();
  const { open, cancel } = props;
  const handleCancel = () => {
    cancel();
  };
  console.log(process.env.ENV_NAME);

  // 列表数据
  const datas = [
    {
      title: t("wo-yao-fa-xu-qiu"),
      icon: `${cdnHost}image/web-site/account_2_2@2x.png?v=${version}`,
    },
    {
      title: t("wo-yao-jie-fu-wu"),
      icon: `${cdnHost}image/web-site/account_1_2@2x.png?v=${version}`,
    },
  ];

  // 跳转对应系统
  const goHref = (type: number) => {
    let url = "";
    // const locale = i18n.language;
    if (type === 0) {
      // 需求方
      url = `${Url.customerUrl()}?locale=${"zh"}`;
      // 埋点
      track(clickEvent.demand_webclick);
    } else {
      // 服务商
      url = `${Url.providerUrl()}?locale=${"zh"}`;
      // 埋点
      track(clickEvent.provision_webclick);
    }
    window.location.href = url;
  };
  return (
    <>
      <Modal
        title=""
        open={open}
        onCancel={handleCancel}
        footer={null}
        wrapClassName={styles["account-wrap"]}
      >
        {/* <div className={styles.title}>{t("zhang-hao-lei-xing")}</div> */}
        {datas.map((item: any, i: number) => {
          return (
            <div
              className={styles.list}
              key={i}
              onClick={() => {
                goHref(i);
              }}
            >
              <Image
                src={item.icon}
                alt=""
                width={120}
                height={88}
                quality={100}
                unoptimized
                className={styles.icon}
              />
              <p>{item.title}</p>
              <div className={styles.tool}>
                <div className={styles.bg}></div>
              </div>
            </div>
          );
        })}
      </Modal>
    </>
  );
};
export default SelectAccount;
